// extracted by mini-css-extract-plugin
module.exports = {"variants":"ax"};